import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  version: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.s,
      letterSpacing: 0.5,
    },
  },
}))

export { useStyles }
